/**
 * @generated SignedSource<<f98b3752b4485578c5ed4153a486e642>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BuildPageQuery$variables = {
  buildLocator: string;
  skip: boolean;
};
export type BuildPageQuery$data = {
  readonly build?: {
    readonly pipelineRun: {
      readonly pipeline: {
        readonly id: Branded<string, 'PipelineId'> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly pipelineRunJob: {
      readonly pipelineRun: {
        readonly build: {
          readonly id: number | null | undefined;
        } | null | undefined;
        readonly pipeline: {
          readonly id: Branded<string, 'PipelineId'> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type BuildPageQuery = {
  response: BuildPageQuery$data;
  variables: BuildPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PipelineRest",
  "kind": "LinkedField",
  "name": "pipeline",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v6 = [
  (v2/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "PipelineRest",
  "kind": "LinkedField",
  "name": "pipeline",
  "plural": false,
  "selections": (v6/*:: as any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildPageQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PipelineRun",
                "kind": "LinkedField",
                "name": "pipelineRun",
                "plural": false,
                "selections": [
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PipelineRunJob",
                "kind": "LinkedField",
                "name": "pipelineRunJob",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PipelineRun",
                    "kind": "LinkedField",
                    "name": "pipelineRun",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Build",
                        "kind": "LinkedField",
                        "name": "build",
                        "plural": false,
                        "selections": (v3/*:: as any*/),
                        "storageKey": null
                      },
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "BuildPageQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PipelineRun",
                "kind": "LinkedField",
                "name": "pipelineRun",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PipelineRunJob",
                "kind": "LinkedField",
                "name": "pipelineRunJob",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PipelineRun",
                    "kind": "LinkedField",
                    "name": "pipelineRun",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Build",
                        "kind": "LinkedField",
                        "name": "build",
                        "plural": false,
                        "selections": (v6/*:: as any*/),
                        "storageKey": null
                      },
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*:: as any*/)
                ],
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3f912f27b421c1a97342eb1cd8ddae08",
    "id": null,
    "metadata": {},
    "name": "BuildPageQuery",
    "operationKind": "query",
    "text": "query BuildPageQuery(\n  $buildLocator: String!\n  $skip: Boolean!\n) {\n  build(buildLocator: $buildLocator) @skip(if: $skip) {\n    pipelineRun {\n      pipeline {\n        id\n        _id\n      }\n    }\n    pipelineRunJob {\n      pipelineRun {\n        build {\n          id\n          _id\n        }\n        pipeline {\n          id\n          _id\n        }\n      }\n      _id\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a675706a89ff328a547dbb6f5e183f6";

export default node;
